jQuery(document).ready(function ($) {

    // check stock with api
    function stockCheck(model) {
        var csrfToken = $('[name="csrf-token"]').attr('content');
        var level = [];

        $.ajax({
            type: 'GET',
            url: '/products/stock-check?model=' + model,
            dataType: 'json',
            cache: false,
            async: false,
            headers: {
                'X-CSRF-TOKEN': csrfToken
            },
            success: function (response) {
                level.status = 200;
                level.error = null;
                level.data = response;
            },
            error: function (error) {
                level.status = 500;
                level.error = 'Error getting stock. ' + error;
                level.data = null;
            },
        });

        return level;
    }

    // prepare html for modal
    function getStockHtml(title, data) {

        var html = '<div class="stock-table__wrapper">';

        html += '<div class="stock-table__header">';
        html += '<h5 class="font-normal text-lg">Distributor stock check</h5>';
        html += '</div>';

        html += '<div class="stock-table__content prose">';

        if (data) {
            if (data.length) {
                html += '<div class="rounded overflow-hidden border border-xp-line-grey">';
                html += '<table class="stock-table__table">';
                html += '<thead><tr><th class="h-model">Model name</th><th class="h-distributor">Distributor</th><th class="h-stock">Quantity</th><th class="h-link">Purchase</th></tr></thead>';
                html += '<tbody>';

                for (var i = 0; i < data.length; i++) {
                    html += '<tr>';

                    if(i == 0) {
                        html += '<td class="model" rowspan="' + data.length + '">';
                        html += title;
                        html += '</td>';
                    }

                    html += '<td class="distributor pl-2">';
                    html += data[i].distributor;
                    html += '</td>';

                    html += '<td class="stock">';
                    html += data[i].stock;
                    html += '</td>';

                    html += '<td class="link">';
                    html += data[i].stock
                        ? '<a class="button button--small" href="' + data[i].link + '" target="_blank">Buy it now</a>'
                        : '<a class="button button--small button--warning" href="' + data[i].link + '" target="_blank">Backorder</a>'

                    html += '</td>';

                    html += '</tr>';
                }

                html += '</tbody>';
                html += '</table>';
                html += '</div>';
            }
            else {
                html += '<p>Sorry, this product is not in stock at the moment. Please contact us directly.</p>';
            }
        } else {
            html += '<p>Sorry, there was an error checking the stock. Please contact us directly.</p>';
        }

        html += '</div>'; // .stock-table__content

        html += '</div>'; // .stock-table__wrapper

        return html;
    }

    // action
    $(document).on('click', '.stock-check', function (e) {
        e.preventDefault();

        var model = $(this).data('model');
        var stocks = stockCheck(model);

        var html = getStockHtml(model, stocks.data || null);

        var modal = $('#stock-modal');
        var stock_div = $('#stock-modal [data-stock]');

        stock_div.html(html);
        modal.foundation('open');
    });
});
